export default function initializePersonalData() {
    document.querySelectorAll('.personal-data').forEach(function (pd) {
        new PersonalData(pd);
    });
}

class PersonalData {
    pd = null;
    baseHref = null;
    params = {};

    constructor(pd) {
        this.pd = pd;
        this.lists = pd.querySelectorAll('.personal-data__list');
        if (additionalProducts) {
            this.params.additional_products = additionalProducts;
        }
        this.lists.forEach((item) => {
            if (item.classList.contains('personal-data__list--child')) {item.list_type = 'child';}
            if (item.classList.contains('personal-data__list--partner')) {item.list_type = 'partner';}
            if (item.classList.contains('personal-data__list--owner')) {item.list_type = 'owner';}
        });

        this.baseHref = window.location;
        this.init();
    }

    init() {
        this.loadActions()
        this.lists.forEach((list) => {
            const Lists = JSON.parse(localStorage.getItem('Lists')) || {};

            if (list.list_type === 'owner') {
                if(!Lists[list.list_type]) {
                    this.addSection(list, true);
                }else{
                    const index = Object.keys(Lists[list.list_type])[0];
                    this.addSection(list, false, index);
                }
            }else{
                for (const section in Lists[list.list_type]) {
                    if (Lists[list.list_type].hasOwnProperty(section)) {
                        this.addSection(list, false, section);
                    }
                }
            }

            const addContainer = list.querySelector('.personal-data__list__add__container');
            if (addContainer) {
                addContainer.addEventListener('click', () => {
                    this.addSection(list);
                });
            }
        });

        this.pd.querySelector('form').addEventListener('submit', async (event) => {
            event.preventDefault();

            const submitButton = event.target.querySelector('button[type="submit"]');

            if (!submitButton.classList.contains('loading')) {

                submitButton.classList.add('loading');

                this.validateData()
                    .then((result) => {
                        if (result) {
                            event.target.submit();
                        }else{
                            submitButton.classList.remove('loading');
                        }
                    })
                    .catch((error) => {
                        submitButton.classList.remove('loading');
                    });
            }
        });
    }

    loadActions() {
        this.removeButtons = this.pd.querySelectorAll('.personal-data__list__top__delete');
        this.lists.forEach((list) => {
            list.querySelectorAll('.personal-data__list__item').forEach((item, index) => {
                item.querySelectorAll('.personal-data__list__top__delete').forEach((button) => {
                    button.addEventListener('click', (event) => {
                        item.remove();
                        const Lists = JSON.parse(localStorage.getItem('Lists')) || {};
                        delete Lists[list.list_type][item.getAttribute('data-section-index')];
                        localStorage.setItem('Lists', JSON.stringify(Lists));
                        list.querySelector('.personal-data__list__add').classList.remove('d-none');
                    });
                });
            });
        });

        let timeout;

        const personalDataContainer = this.pd.closest('.personal-data');

        if (personalDataContainer) {
            const headers = personalDataContainer.querySelectorAll('.personal-data__list__item__packet__select__header');
            headers.forEach((header) => {
                if (!header.dataset.eventAssigned) {
                    header.addEventListener('click', function() {
                        const select = this.closest('.personal-data__list__item__packet__select');

                        if (select.classList.contains('active')) {
                            select.classList.remove('active');
                        } else {
                            const activeSelect = personalDataContainer.querySelector('.personal-data__list__item__packet__select.active');
                            if (activeSelect) {
                                activeSelect.classList.remove('active');
                            }

                            select.classList.add('active');
                        }
                    });
                    header.dataset.eventAssigned = true;
                }
            });
        }

        this.lists.forEach((list) => {
            list.querySelectorAll('.personal-data__list__item').forEach((item) => {
                const inputs = item.querySelectorAll('form input');
                inputs.forEach((input) => {
                    if (!input.dataset.inputEventAssigned) {
                        input.dataset.inputEventAssigned = true;

                        if (input.type === 'radio') {

                            const isPreferredLangRadio = input.name.startsWith('preferred_contact_language');

                            if (isPreferredLangRadio) {
                                input.addEventListener('mousedown', (e) => {
                                    input.wasChecked = input.checked;
                                });

                                input.addEventListener('click', (event) => {
                                    if (input.classList.contains('disabled')) {
                                        event.preventDefault();
                                        return;
                                    }

                                    if (input.wasChecked) {
                                        input.checked = false;

                                        const evt = new Event('change', { bubbles: true });
                                        input.dispatchEvent(evt);
                                    } else {
                                        this.updateRadio();
                                    }

                                    clearTimeout(timeout);
                                    timeout = setTimeout(() => {
                                        this.validateData(false);
                                        this.saveSession(item, list.list_type);
                                    }, 1000);
                                });
                            } else {
                                input.addEventListener('click', (event) => {
                                    if (input.classList.contains('disabled')) {
                                        event.preventDefault();
                                    }else{
                                        this.updateRadio()
                                    }

                                    clearTimeout(timeout);
                                    timeout = setTimeout(() => {
                                        this.validateData(false);
                                        this.saveSession(item, list.list_type);
                                    }, 1000);
                                });
                            }

                        }else {
                            input.addEventListener('input', (event) => {

                                clearTimeout(timeout);
                                timeout = setTimeout(() => {
                                    this.validateData(false);
                                    this.saveSession(item, list.list_type);
                                }, 1000);
                            });
                        }
                    }
                });
            });
        });

        this.initializePesel();
        this.initializeZipCode();
        this.initializeSelects();
        this.initializeCommunicationConsent();
        this.updateRadio();
    }

    updateRadio() {
        const groups = {};

        this.pd.querySelectorAll('.radio-packet').forEach(radio => {
            // radio.disabled = false;
            radio.classList.remove('disabled');
        });

        this.pd.querySelectorAll('.radio-packet:checked').forEach(selected => {
            const dataId = selected.dataset.id;
            groups[dataId] = (groups[dataId] || 0) + 1;
        });

        this.pd.querySelectorAll('.personal-data__list__item__packet__select__list').forEach(item => {
            const radios = item.querySelectorAll('.radio-packet');

            radios.forEach(radio => {
                const dataId = radio.dataset.id;
                const dataMax = parseInt(radio.dataset.max, 10);
                const count = groups[dataId] || 0;

                radio.dataset.use = count;

                const label = radio.closest('div').querySelector('label');
                if (label && label.querySelector('.packet-count')) {
                    label.querySelector('.packet-count').textContent = dataMax - count;
                }

                if (dataId !== 'none' && count >= dataMax) {
                    radio.classList.add('disabled');
                } else {
                    radio.classList.remove('disabled');
                }
            });

            const selected = item.querySelector('.radio-packet:checked');
            if (selected && selected.labels.length > 0) {
                const newTitle = selected.labels[0].innerText.split('(')[0].trim();
                item.closest('.personal-data__list__item__packet__select')
                    .querySelector('.personal-data__list__item__packet__select__header').innerText = newTitle;
            }
        });
    }

    async validateData(scroll = true) {
        return new Promise((resolve, reject) => {
            const form = document.querySelector('form');
            const data = new FormData(form);

            const xhr = new XMLHttpRequest();
            xhr.open('POST', this.baseHref.origin + '/wp-json/f/v1/pd/data_validation/');

            xhr.onload = () => {
                if (xhr.status !== 200) {
                    console.error(`Error ${xhr.status}: ${xhr.statusText}`);
                    window.alert(`Error ${xhr.status}: ${xhr.statusText}`);
                    reject(false);
                } else {
                    try {
                        const response = JSON.parse(xhr.responseText);

                        if (response.success !== false) {
                            form.querySelectorAll('.personal-data__list__item__input').forEach(inputDiv => {
                                inputDiv.classList.remove('invalid');
                                if (inputDiv.querySelector('.input-error')) {
                                    inputDiv.querySelector('.input-error').innerHTML = '';
                                }
                            });

                            let firstErrorField = null;

                            for (const key in response.errors) {
                                for (const input in response.errors[key]) {
                                    for (const i in response.errors[key][input].data) {
                                        const data = response.errors[key][input].data[i];
                                        const name = `${i}[${key}][${input}]`;
                                        const item = form.querySelector(`input[name="${name}"]`);

                                        if (item && item.classList.contains('pesel-input')) {
                                            if (data) {
                                                const birthdate = form.querySelector(`input[name="birthdate[${key}][${input}]"]`);
                                                if (birthdate) {
                                                    birthdate.value = data.birthdate;
                                                }

                                                if (data.gender) {
                                                    const maleInput = form.querySelector(`input[name="gender[${key}][${input}]"][value="m"]`);
                                                    const femaleInput = form.querySelector(`input[name="gender[${key}][${input}]"][value="k"]`);

                                                    if (maleInput && femaleInput) {
                                                        if (data.gender === 'm') {
                                                            maleInput.checked = true;
                                                        } else if (data.gender === 'k') {
                                                            femaleInput.checked = true;
                                                        }
                                                    }
                                                }

                                                this.saveSession(item.closest('.personal-data__list__item'), item.closest('.personal-data__list').list_type);
                                            }
                                        }
                                    }
                                    for (const i in response.errors[key][input].errors) {
                                        const error = response.errors[key][input].errors[i];
                                        const name = `${i}[${key}][${input}]`;
                                        const item = form.querySelector(`input[name="${name}"]`);

                                        if (item) {
                                            const listItemInput = item.closest('.personal-data__list__item__input');
                                            listItemInput.classList.add('invalid');
                                            listItemInput.querySelector('.input-error').innerHTML = error;
                                            if (!firstErrorField) {
                                                firstErrorField = item;
                                            }
                                        }
                                    }
                                }
                            }

                            if (scroll) {
                                if (firstErrorField) {
                                    const yOffset = -50;
                                    const y = firstErrorField.getBoundingClientRect().top + window.pageYOffset + yOffset;

                                    window.scrollTo({
                                        top: y,
                                        behavior: 'smooth'
                                    });

                                    resolve(false);
                                } else {
                                    resolve(true);
                                }
                            } else {
                                resolve(true);
                            }
                        } else {
                            reject(false);
                        }

                    } catch (e) {
                        console.error('Error parsing response', e);
                        reject(false);
                    }
                }
            };

            xhr.onerror = () => {
                console.error('Request failed');
                reject(false);
            };

            xhr.send(data);
        });
    }

    addSection(list, save = true, index = null) {
        let DOM = list.querySelector('.personal-data__list__content');
        let xhr = new XMLHttpRequest();
        if (!index) {
            index = this.generateRandomIndex();
        }

        this.params.list_type = list.list_type;
        this.params.data_section_index = index;
        this.params.lang = document.documentElement.lang;
        list.querySelector('.personal-data__list__loader').classList.remove('d-none');

        xhr.open('GET', this.baseHref.origin + '/wp-json/f/v1/pd/add_section/?params=' + JSON.stringify(this.params));
        xhr.send();
        xhr.onload = () => {
            if (xhr.status !== 200) {
                console.error(`Error ${xhr.status}: ${xhr.statusText}`);
                window.alert(`Error ${xhr.status}: ${xhr.statusText}`);
            } else {
                try {
                    DOM.insertAdjacentHTML('beforeend', JSON.parse(xhr.responseText));
                    const newSection = list.querySelector(`.personal-data__list__item[data-section-index="${index}"]`);

                    if (save) {
                        const Lists = JSON.parse(localStorage.getItem('Lists')) || {};
                        if (!Lists[list.list_type]) {Lists[list.list_type] = {};}
                        Lists[list.list_type][index] = '';
                        localStorage.setItem('Lists', JSON.stringify(Lists));
                    }else{
                        this.loadSectionAndDataForm(list, index);
                    }

                    list.querySelector('.personal-data__list__loader').classList.add('d-none');

                    if (list.list_type === 'partner') {
                        list.querySelector('.personal-data__list__add').classList.add('d-none');
                    }

                    this.loadActions();
                    this.autoSelectOption();
                    return newSection;
                } catch (e) {
                    console.log(e)
                }
            }

        };
        xhr.onerror = () => {
            console.log('Request failed');
        };
    }

    generateRandomIndex() {
        return Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    }

    saveSession(item, list_type) {
        const index = item.getAttribute('data-section-index');
        const formDataObject = {};
        const inputs = item.querySelectorAll('.personal-data__list__item__container input');
        inputs.forEach((input) => {
            if (input.type === 'radio' && !input.checked) {
                return;
            }

            if (input.type === 'checkbox') {
                formDataObject[input.name] = input.checked;
            } else {
                formDataObject[input.name] = input.value;
            }
        })

        const Lists = JSON.parse(localStorage.getItem('Lists')) || {};
        if (!Lists[list_type]) {
            Lists[list_type] = {};
        }

        Lists[list_type][index] = formDataObject;
        localStorage.setItem('Lists', JSON.stringify(Lists));
    }

    loadSectionAndDataForm(list, index) {
        const item = list.querySelector(`.personal-data__list__item[data-section-index="${index}"]`);
        if (item) {
            const Lists = JSON.parse(localStorage.getItem('Lists')) || {};
            const formData = Lists[list.list_type][index];
            const form = item.querySelector('.personal-data__list__item__container');

            if (formData) {
                Object.keys(formData).forEach((key) => {
                    const element = formData[key];
                    const data = key.split('[');
                    const input = form.querySelectorAll(`input[name="${key}"]`);

                    if (input.length > 1) {
                        input.forEach((input) => {
                            if (input.type === 'radio') {
                                if (input.value === element) {
                                    input.checked = true;
                                }
                            }else{
                                input.value = element;
                            }
                        });
                    }else{
                        if (input.length > 0){
                            input.forEach((input) => {
                                if (input.type === 'checkbox') {
                                    if (element === true || element === 'true') {
                                        input.checked = true;
                                    } else {
                                        input.checked = false;
                                    }
                                }else{
                                    input.value = element;
                                }
                            });
                        }
                    }
                });
            }
        }
    }

    initializePesel() {
        document.querySelectorAll('.pesel-input').forEach(function(inputPeselField) {
            inputPeselField.addEventListener('input', function(event) {
                let inputValue = this.value.replace(/\D/g, '');
                inputValue = inputValue.substring(0, 11);

                let formattedValue = '';
                let newCursorPosition = this.selectionStart;
                const placeholder = '_';
                for (let i = 0; i < 11; i++) {
                    formattedValue += inputValue[i] || placeholder;
                }

                if (event.inputType === 'deleteContentBackward' && this.selectionStart < newCursorPosition) {
                    newCursorPosition = this.selectionStart;
                }

                this.value = formattedValue;
                this.setSelectionRange(newCursorPosition, newCursorPosition);
            });
        });
    }

    initializeZipCode() {
        document.querySelectorAll('.zip-code').forEach(function(inputZipCodeField) {
            inputZipCodeField.addEventListener('input', function(event) {
                let inputValue = this.value.replace(/\D/g, '');
                inputValue = inputValue.substring(0, 5);
                if (inputValue.length !== 6) {
                    let formattedValue = '';
                    let newCursorPosition = this.selectionStart;
                    const placeholder = '_';
                    for (let i = 0; i < 5; i++) {
                        if (i === 2) {
                            formattedValue += '-';
                            if (newCursorPosition === 2) {
                                newCursorPosition++;
                            }
                        }
                        formattedValue += inputValue[i] || placeholder;
                    }

                    if (event.inputType === 'deleteContentBackward') {
                        if (this.selectionStart === 3) {
                            newCursorPosition = 2;
                        }
                    }

                    this.value = formattedValue;
                    this.setSelectionRange(newCursorPosition, newCursorPosition);
                }
            });
        });
    }

    initializeSelects() {
        const personalDataContainer = this.pd.closest('.personal-data');

        if (personalDataContainer) {
            const headers = personalDataContainer.querySelectorAll('.personal-data__list__item__packet__select__header');

            const closeAllSelects = () => {
                const activeSelect = personalDataContainer.querySelector('.personal-data__list__item__packet__select.active');
                if (activeSelect) {
                    activeSelect.classList.remove('active');
                }
            };

            headers.forEach((header) => {
                if (!header.dataset.eventAssigned) {
                    header.addEventListener('click', function (event) {

                        const select = this.closest('.personal-data__list__item__packet__select');

                        if (select.classList.contains('active')) {
                            select.classList.remove('active');
                        } else {
                            closeAllSelects();
                            select.classList.add('active');
                        }
                    });

                    header.dataset.eventAssigned = true;
                }
            });

            document.addEventListener('click', (event) => {
                if (!event.target.closest('.personal-data__list__item__packet__select')) {
                    closeAllSelects();
                }
            });
        }
    }

    autoSelectOption() {
        if (categoryField === 18){
            const radios = document.querySelectorAll('.personal-data__list__item__packet__select__list .radio-packet');
            radios.forEach((radio) => {
                if (radio.value !== 'none') {
                    radio.checked = true;
                    this.updateRadio();
                }
            })
        }
    }

    initializeCommunicationConsent() {
        const master = this.pd.querySelector('#communication_consent_all');
        const options = this.pd.querySelectorAll('.communication-consent-option');

        if (!master || options.length === 0) return;

        master.addEventListener('change', () => {
            options.forEach(cb => cb.checked = master.checked);
        });

        options.forEach(cb => {
            cb.addEventListener('change', () => {
                const allChecked = Array.from(options).every(opt => opt.checked);
                master.checked = allChecked;
            });
        });
    }


}